"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resizer = void 0;
var meta_1 = require("./meta");
var message_type_1 = require("../bridge/message-type");
var Resizer = /** @class */ (function () {
    function Resizer() {
    }
    Resizer.setup = function () {
        var _this = this;
        $(window).resize(function () {
            _this.requestWindowResize();
        });
        this.onElementHeightChange(document.body, function () {
            _this.requestWindowResize();
        });
        this.requestWindowResize();
    };
    Resizer.requestWindowResize = function () {
        // Different browsers handle the height calculation differently - we use the minimum value
        // https://stackoverflow.com/questions/1145850/how-to-get-height-of-entire-document-with-javascript
        var documentElementHeight = document.documentElement.scrollHeight; // Works in Safari
        var bodyHeight = document.body.scrollHeight; // Works in Chrome & Firefox
        var minimumHeight = Math.min(documentElementHeight, bodyHeight);
        parent.postMessage({
            type: message_type_1.MessageType.Resize,
            height: minimumHeight,
            host: !meta_1.Meta.hasCanonical ? window.location.href : null,
        }, meta_1.Meta.host);
    };
    Resizer.onElementHeightChange = function (elm, callback) {
        var lastHeight = elm.clientHeight, newHeight;
        (function run() {
            newHeight = elm.clientHeight;
            if (lastHeight !== newHeight)
                callback();
            lastHeight = newHeight;
            if (elm.onElementHeightChangeTimer)
                clearTimeout(elm.onElementHeightChangeTimer);
            elm.onElementHeightChangeTimer = setTimeout(run, 200);
        })();
    };
    return Resizer;
}());
exports.Resizer = Resizer;
